import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';
import {emitTrackEvent, hasSlot} from '../../util/dom';

import {TrackingEvent} from './tracking';

import template from './index.jade';
import css from './index.styl?inline';

const COMPONENT_NAME = `mp-collapsible`;

export default registerMPElement(
  COMPONENT_NAME,
  class extends Component {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        'header-title': `string`,
        'is-closed': `boolean`,
      };
    }

    get config() {
      return {
        css,
        template,
        useShadowDom: true,

        defaultState: {
          isOpen: true,
        },

        helpers: {
          hasSlot,

          toggleOpen: () => {
            const isOpen = !this.state.isOpen;
            const state = isOpen ? `open` : `closed`;

            this.update({isOpen});
            this.track(state);
            this.dispatchEvent(new CustomEvent(`change`, {detail: {state}}));
          },
        },
      };
    }

    attributeChangedCallback(attr, oldVal, newVal) {
      super.attributeChangedCallback(attr, oldVal, newVal);

      if (attr === `is-closed`) {
        this.update({isOpen: !this.attr(`is-closed`)});
      }
    }

    track(state) {
      const event = state === `open` ? TrackingEvent.OpenedCollapsibleSection : TrackingEvent.ClosedCollapsibleSection;
      emitTrackEvent(this, {
        eventName: event,
        eventPrefix: COMPONENT_NAME,
        props: {
          'Collapsible state': state,
          'Section name': this.attr(`header-title`),
        },
        cancelable: true,
      });
    }
  },
);
